import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Experiment to control to enable Out of Stock (OOS) enhancements on PDP.
 */
export const FE_ENABLE_PDP_OOS_ENHANCEMENTS_250409 = experiment({
  name: "FE_ENABLE_PDP_OOS_ENHANCEMENTS_250409",
  defaultValue: false,
  identifier: "RetailerToken",
  client: ["RETAILER", "VISITOR_WEB"],
  productArea: "BRAND_CATALOG_COMPLETENESS",
  notifyAfter: "2025-07-09",
});
